import GiftCardDestination from '@square/dashboard-data/models/squareup/beemo/api/v2/models/gift-card-destination';
import TenderDestination from '@square/dashboard-data/models/squareup/beemo/api/v2/models/tender-destination';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  giftCardDestination: attr(GiftCardDestination),
  tenderDestination: attr(TenderDestination)
});